import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "../../../src/component/Header";
import IconDelete from "../../../src/component/SvgIcons/IconDelete";
import IconPen from "../../../src/component/SvgIcons/IconPen";
import IconPlus from "../../../src/component/SvgIcons/IconPlus";
import IconUpdownFilter from "../../../src/component/SvgIcons/IconUpdownFilter";
import Pagination from "../../component/Pagination";
import IconSearch from "../../component/SvgIcons/IconSearch";
import api from "../../Services/api";
import "../Events/style.css";
import { Tooltip } from "react-tooltip";

import { formatCountryDate } from "../../Services/countryTime";
export default function TallyAddons() {
  const [users, setUsers] = useState([]); // Initially empty, will be filled from API
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1920) {
        setItemsPerPage(20);
      } else {
        setItemsPerPage(10);
      }
    };
    handleResize(); // Set initial value
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchTallyAddons = async () => {
      try {
        const response = await api.post("/getTallyAddons");
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching Tally Addons:", error);
      }
    };

    fetchTallyAddons();
  }, []);

useEffect(() => {
  const fetchBlogs = async () => {
    try {
      const response = await api.post("/AllBlogView");
      const blogsdata = response.data.reverse();
      console.log("blogsdata", blogsdata); // 👈 check what field has the URL
      setBlogs(blogsdata);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };
  fetchBlogs();
}, []);


  
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedUsers = [...users].sort((a, b) => {
    if (!sortConfig.key) return 0;
    if (a[sortConfig.key] < b[sortConfig.key])
      return sortConfig.direction === "asc" ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key])
      return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  const filteredTallyAddons = sortedUsers.filter((user) =>
    user.tally.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredTallyAddons.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(filteredTallyAddons.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    if (!result.isConfirmed) return;

    try {
      // Send the ID in the request body
      await api.post("/deleteTally", { id });

      // Update UI after deletion
      setUsers((prevUsers) => prevUsers.filter((user) => user.id !== id));
      await Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "User deleted successfully.",
      });
    } catch (error) {
      console.error("Error deleting user:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "An error occurred while deleting the user.",
      });
    }
  };

  return (
    <section className="eventpage">
      <Header pageTitle="Tally Addons Details" />
      <div className="pageLeftspace">
        <div className="d-flex justify-content-between align-items-center topsearchbar">
          <div className="d-flex align-items-center gap-2">
            <Link to="/add-tally-addons" className="btn btn-purpal addbutton">
              <IconPlus /> Add Tally Addons
            </Link>

            <Link to="#" onClick={() => handleSort("tally")}>
              <IconUpdownFilter />
            </Link>
          </div>

          <div className="input-container">
            <input
              type="text"
              id="name"
              value={searchQuery}
              onChange={handleSearchChange}
              placeholder="Search Here.."
            />
            {/* <label htmlFor="name">Search</label> */}
            <span className="underline"></span>
            <div className="search-icon">
              <IconSearch />
            </div>
          </div>
        </div>

        <div className="tableheader d-flex flex-column gap-4">
          <div className="event-detailstable">
            <table className="table">
              <thead>
                <tr>
                  <th width="10px" align="center">
                    Sr. No.
                  </th>
                  <th>Date</th>
                  <th>Tally Addons</th>
                  <th>Tally Icon</th>
                  <th>Tally Url</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.length > 0 ? (
                  currentUsers.map((user, index) => (
                    <tr key={user.id}>
                      <td align="center">{index + 1}</td>
                      <td>
                        {formatCountryDate(user.DateTime)
                          .replace(/\//g, "-")}
                      </td>
                      <td>{user.tally}</td>
                      <td>
                        {user.Tally_Icon ? (
                          <a
                            href={`${process.env.REACT_APP_API_PRJ_URL}/uploads/tallyfile/${user.Tally_Icon}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${process.env.REACT_APP_API_PRJ_URL}/uploads/tallyfile/${user.Tally_Icon}`}
                              alt="Tally Icon"
                              style={{ width: "50px", height: "auto", borderRadius: "5px" }}
                            />
                          </a>
                        ) : (
                          <span>No Icon</span>
                        )}
                      </td>
                      <td>
                      {user.Tally_Url && blogs.some(blog => blog.view_url === user.Tally_Url) ? (
                        <a
                          href={user.Tally_Url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#007bff", textDecoration: "underline" }}
                        >
                          {user.Tally_Url}
                        </a>
                      ) : (
                        <span>No URL</span>
                      )}
                    </td>

                      <td>
                        <div className="action">
                          <Link
                            to={`/edit-tally-addon/${user.id}`}
                            className="editbtn"
                            data-tooltip-id={`edit-${user.id}`}
                            data-tooltip-content="Edit"
                          >
                            <IconPen />
                          </Link>
                          <Tooltip id={`edit-${user.id}`} place="top" />

                          <Link onClick={() => handleDelete(user.id)}
                            data-tooltip-id={`delete-${user.id}`}
                            data-tooltip-content="Delete">

                            <IconDelete />
                          </Link>
                          <Tooltip id={`delete-${user.id}`} place="top" />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={
              filteredTallyAddons.length > itemsPerPage ? totalPages : 0
            }
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </section>
  );
}
